import { Fragment } from "react";
import { FormReceivedType } from "../types";
import { AttachmentSection } from "../../components";
import { useFormContext } from "react-hook-form";

export function AttachmentModal(): JSX.Element {
    const { control, getValues, setValue, watch } = useFormContext<FormReceivedType>()
    const trx_code = watch('trx_code')

    return (
        <Fragment>
            <AttachmentSection<FormReceivedType>
                addApi="/received/uploadfile"
                removeApi="/received/removefile?strPath"
                trx_code={trx_code!}
                control={control}
                setValue={setValue}
                getValues={getValues}
                name="imgPath"
            />
        </Fragment>
    )
}
